function getHeader (){
  let query = location.search;
      query = query ? query + "&view=header" : query +  "?view=header";
  
  fetch(query).then(function (response) {
     return response.text()
      
  } ).then((data) => {
  
      data = data.replace(
        "?-mix:\\('shopify.content_for_header.end'\\);<\\/script>)",
        `('shopify.content_for_header.end'));</script>`
      );
      data = data
      .replace("\u0026view=header", "")
      .replace("?view=header", "");
      $("head").eq(0).append(data)
      if(window.asyncLoad) window.asyncLoad();
  })
  
 
}

//getHeader()